import {
  AfterContentInit,
  Directive,
  ElementRef,
  Injectable,
  Input,
  NgModule,
  Renderer2,
} from '@angular/core';
import { NgxAnalytics } from './ngx-analytics';



export class NgxAnalyticsOn implements AfterContentInit {
   ngxAnalyticsOn: string;
   angularticsAction: string;
   angularticsCategory: string;
   angularticsLabel: string;
   angularticsValue: string;
   angularticsProperties: any = {};

  constructor(
    private elRef: ElementRef,
    private ngxAnalytics: NgxAnalytics,
    private renderer: Renderer2
  ) { }

  ngAfterContentInit() {
    this.renderer.listen(
      this.elRef.nativeElement,
      this.ngxAnalyticsOn || 'click',
      (event: Event) => this.eventTrack(event),
    );
  }

  eventTrack(event: Event) {
    const action = this.angularticsAction; // || this.inferEventName();
    const properties: any = {
      ...this.angularticsProperties,
      eventType: event.type,
    };

    if (this.angularticsCategory) {
      properties.category = this.angularticsCategory;
    }
    if (this.angularticsLabel) {
      properties.label = this.angularticsLabel;
    }
    if (this.angularticsValue) {
      properties.value = this.angularticsValue;
    }

    this.ngxAnalytics.eventTrack.next({
      action,
      properties,
    });
  }

  /*private isCommand() {
    return ['a:', 'button:', 'button:button', 'button:submit', 'input:button', 'input:submit'].indexOf(
      getDOM().tagName(this.el).toLowerCase() + ':' + (getDOM().type(this.el) || '')) >= 0;
  }

  private inferEventName() {
    if (this.isCommand()) return getDOM().getText(this.el) || getDOM().getValue(this.el);
    return getDOM().getProperty(this.el, 'id') || getDOM().getProperty(this.el, 'name') || getDOM().tagName(this.el);
  }*/
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
{ type: Directive, args: [{ selector: '[ngx-analyticsOn]' }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: NgxAnalytics, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngxAnalyticsOn': [{ type: Input, args: ['ngx-analyticsOn', ] },],
'angularticsAction': [{ type: Input },],
'angularticsCategory': [{ type: Input },],
'angularticsLabel': [{ type: Input },],
'angularticsValue': [{ type: Input },],
'angularticsProperties': [{ type: Input },],
};
}


export class NgxAnalyticsOnModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [NgxAnalyticsOn],
  exports: [NgxAnalyticsOn],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
